module.exports = __webpack_public_path__ + "img/avatar-drinking-beer.b7010dbc.png";